module.exports = __webpack_public_path__ + "static/media/logo-shadow.6a329f99.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/nolimit/logo-shadow.png
// module id = 242
// module chunks = 0